export default __webpack_public_path__ + "static/product4-31b75adc48f855015c5c763698a14cb2.png";